import { render, staticRenderFns } from "./addColor.vue?vue&type=template&id=1dc10853&scoped=true"
import script from "./addColor.vue?vue&type=script&lang=js"
export * from "./addColor.vue?vue&type=script&lang=js"
import style0 from "./addColor.vue?vue&type=style&index=0&id=1dc10853&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc10853",
  null
  
)

export default component.exports